export default class InitState extends Phaser.State {
  init () {
    this.game.renderer.renderSession.roundPixels = true
    Phaser.Canvas.setImageRenderingCrisp(this.game.canvas)

    this.stage.backgroundColor = '#000'

    this.scale.scaleMode = Phaser.ScaleManager.USER_SCALE
    this.scale.setUserScale(2, 2)

    this.selectedMenuItem = 0

    if (!window.localStorage.getItem('level')) {
      window.localStorage.setItem('level', '0')
    }
  }

  preload () {
    this.load.atlas('sloth', ASSETS.objectsMapImage, ASSETS.slothData, Phaser.Loader.TEXTURE_ATLAS_JSON_HASH)
    this.load.bitmapFont('monospace', ASSETS.monospaceFontImage, ASSETS.monospaceFontData)
    this.load.spritesheet('tilemap', ASSETS.tileMapImage, TILE_WIDTH, TILE_HEIGHT)
    this.load.image('item', 'assets/mushroom.png')
    this.game.load.audio('music', ['assets/music.mp3'])
  }

  create () {
    const music = this.game.add.audio('music')
    music.loop = true
    music.play()

    this.add.bitmapText(16, 16, 'monospace', 'GENERATION 0xDEADBEEF', 9)

    const currentLevel = parseInt(window.localStorage.getItem('level'))

    let startText = (currentLevel > 0) ? 'CONTINUE' : 'START'

    this.menuItems = [
      this.add.bitmapText(16, 50, 'monospace', startText, 9),
      this.add.bitmapText(16, 62, 'monospace', 'LEVEL SELECT', 9),
      this.add.bitmapText(16, 74, 'monospace', 'CONTROLS', 9),
      this.add.bitmapText(16, 86, 'monospace', 'CREDITS', 9)
    ]

    this.selectedMenuItem = 0
    this.updateItems()

    const onUp = () => {
      this.selectedMenuItem--
      if (this.selectedMenuItem < 0) {
        this.selectedMenuItem = 3
      }
      this.updateItems()
    }

    const onDown = () => {
      this.selectedMenuItem++
      if (this.selectedMenuItem > 3) {
        this.selectedMenuItem = 0
      }
      this.updateItems()
    }

    const upKey = this.game.input.keyboard.addKey(Phaser.Keyboard.UP)
    upKey.onDown.add(() => { onUp() })
    const wKey = this.game.input.keyboard.addKey(Phaser.Keyboard.W)
    wKey.onDown.add(() => { onUp() })
    const downKey = this.game.input.keyboard.addKey(Phaser.Keyboard.DOWN)
    downKey.onDown.add(() => { onDown() })
    const sKey = this.game.input.keyboard.addKey(Phaser.Keyboard.S)
    sKey.onDown.add(() => { onDown() })

    const onEnter = () => {
      switch (this.selectedMenuItem) {
        case 0: this.state.start('text', true, false, currentLevel); break
        case 1: this.state.start('levelSelect', true, false, 0); break
        case 2: this.state.start('controls', true, false, 0); break
        case 3: this.state.start('credits', true, false, 0); break
      }
    }

    const enterKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ENTER)
    enterKey.onDown.add(() => { onEnter() })
    const mKey = this.game.input.keyboard.addKey(Phaser.Keyboard.M)
    mKey.onDown.add(() => { onEnter() })
  }

  updateItems () {
    for (const i in this.menuItems) {
      this.menuItems[i].alpha = ((i == this.selectedMenuItem) ? 1 : 0.5)
    }
  }
}
